import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { skipWhile, map, take } from 'rxjs/operators';
import { getPermissionState } from '../redux/reducers';
import { State } from '../redux/reducers/reducers-permission';

@Injectable()
export class PermissionsConfigGuard implements CanActivate {
  constructor(private readonly store: Store<any>, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.store.pipe(select(getPermissionState)).pipe(
      skipWhile((permission: State) => permission.isLoading),
      take(1),
      map((permission: State) => {
        if (!permission.isLoading && route.data.permission && permission.data.indexOf(route.data.permission) === -1) {
          this.router.navigate(['/403']);
        }
        return true;
      })
    );
  }
}
